import * as L from 'leaflet';
import { Marker } from 'react-leaflet';
import './style.scss';
import { ICoordinate } from '../../../../../../../../../models/coordinate.model';

function JourneyEndpointMarker({ coordinate, text }: { coordinate: ICoordinate; text: string }) {
  const icon = L.divIcon({
    className: 'div-icon journey-endpoint-marker',
    iconSize: [42, 55],
    iconAnchor: [21, 55],
    html: `<span class="position-absolute fg-white w-100" style="margin-top: 6px; left: 0;">${text}</span>
      <img src="/icons/map-marker-empty.svg" alt="" class="w-100 h-100" />`,
  });

  return <Marker zIndexOffset={999} icon={icon} position={[coordinate.latitude, coordinate.longitude]} />;
}

export default JourneyEndpointMarker;
